/**
 * Create the store with dynamic reducers
 */

import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { createInjectorsEnhancer, forceReducerReload } from 'redux-injectors';
import createSagaMiddleware from 'redux-saga';

import { createReducer } from './reducers';

export default function configureAppStore(initialState = {}) {
  const publicUrl = (import.meta.env.BASE_URL || '/').replace(/\/$/, '');
  const enableStateWarnings = process.env.NODE_ENV === 'development';
  // We don't want thank to be part of getDefaultMiddleware middleware list
  const defaultMiddleWares = getDefaultMiddleware({
    thunk: false,
    immutableCheck: enableStateWarnings,
    serializableCheck: enableStateWarnings,
  });

  const reduxSagaMonitorOptions = {};
  const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);
  const { run: runSaga } = sagaMiddleware;

  // Create the store with saga middleware
  const middlewares = [sagaMiddleware];

  const enhancers = [
    createInjectorsEnhancer({
      createReducer,
      runSaga,
    }),
  ];

  const store = configureStore({
    reducer: createReducer(),
    preloadedState: initialState,
    middleware: [...defaultMiddleWares, ...middlewares],
    devTools:
      /* istanbul ignore next line */
      process.env.NODE_ENV !== 'production' || publicUrl.length > 0,
    enhancers,
  });

  /* istanbul ignore next */
  if (import.meta.hot) {
    import.meta.hot.accept('./reducers', () => {
      forceReducerReload(store);
    });
  }

  return store;
}
